import { useRef } from 'react';
import type { ReactNode } from 'react';
import Container from './Container';
import ScrollExpandPhoto from './ScrollExpandPhoto';
import Eyebrow from '@/components/base/Eyebrow';

interface Props {
  eyebrow: string;
  title: ReactNode;
  intro: string;
  img: string;
  alt: string;
  children?: ReactNode;
}

export default function SplitHero({ eyebrow, title, intro, img, alt, children }: Props) {
  const boxRef = useRef<HTMLDivElement>(null);
  return (
    <section className="pt-10 md:pt-16 pb-16 md:pb-24">
      <Container>
        <div ref={boxRef} className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <Eyebrow>{eyebrow}</Eyebrow>
            <h1 className="mt-5 text-[36px] sm:text-[48px] lg:text-[54px] xl:text-[64px] lg:whitespace-nowrap leading-[1.02] font-medium tracking-[-0.02em]">{title}</h1>
          </div>
          <div className="max-w-sm shrink-0 md:max-w-[300px] xl:max-w-sm">
            <p className="text-[16px] md:text-[18px] leading-relaxed text-foreground-700">{intro}</p>
            {children && <div className="mt-6 flex flex-wrap gap-3">{children}</div>}
          </div>
        </div>
      </Container>
      <ScrollExpandPhoto src={img} alt={alt} alignRef={boxRef} />
    </section>
  );
}